import useReveal from '@/hooks/useReveal';
import useSmoothScroll from '@/hooks/useSmoothScroll';
import Header from './components/Header';
import Hero from './components/Hero';
import { Manifesto, Expertise } from './components/Editorial';
import { Approach, Focus, Signals } from './components/Method';
import Contact from './components/Contact';
import Closing from './components/Closing';
import VisualWorld from '@/components/feature/VisualWorld';

export default function Home() {
  useReveal();
  useSmoothScroll();
  return (
    <div className="text-foreground-950">
      <VisualWorld />
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:z-[60] focus:p-3 focus:bg-accent-500">Skip to content</a>
      <Header />
      <main id="main" className="relative z-10">
        <Hero />
        <Manifesto />
        <Expertise />
        <Approach />
        <Focus />
        <Signals />
        <Closing />
        <Contact />
      </main>
    </div>
  );
}